export default __webpack_public_path__ + "static/media/cta-search.deb2d553.svg";